import {Injectable} from '@angular/core';
import {Report} from '../models/report.model';
import {AdminService} from './admin.service';

@Injectable()
export class ReportService {
  reportsMin = [];
  filteredReports: Report[] = [];
  allReports: Report[];

  rowNames: any[] = [];

  reportDate = '';

  public data = [];

  constructor(public adminService: AdminService) {
  }

  setData(a) {
    this.data = [];
    this.data.push(...a);
  }

  getData() {
    return this.data;
  }

  filter(report: Report) {
    let index: number = this.reportsMin.indexOf(report);
    if (index > -1) {
      this.reportsMin.splice(index, 1);
      this.filteredReports.push(report);
    } else {
      index = this.filteredReports.indexOf(report);
      if (index > -1) {
        this.filteredReports.splice(index, 1);
        this.reportsMin.push(report);
      }
    }
  }

  clearRowNames() {
    this.rowNames = [];
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/report.service.ts